/**
 * A phone number with all but its last 4 digits hidden, for lists where
 * staff need to tell patients apart but not call them (e.g. the examiner's
 * exam list). Numbers of 4 digits or fewer are hidden entirely.
 */
export function maskPhone(phone: string | undefined | null): string {
  const digits = (phone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 4) return '••••';
  return `•••• ${digits.slice(-4)}`;
}
